module.exports = __webpack_public_path__ + "media/images/welcome-a05a3d347effa1bd17984ac739003589.svg";